<template>
  <div class="wrapper text-center pt-12">
    <div class="inner-wrapper mt-12">
      <p
        class="body-1"
      >Thank you for submitting your team, your players should receive an email to activate and complete their player profile. Please make sure each player completes the activation step and fills out their profile so college coaches have the most up to date information.</p>
      <p class="body-1 mb-10">
        Thank you for your support of the Intercollegiate Men's Lacrosse Coaches Association, if you have any questions please email
        <a
          href="mailto: playersdirectory@imlcacoaches.com"
          class="primary--text"
        >playersdirectory@imlcacoaches.com</a>
      </p>

      <v-btn large color="primary" @click="reset">Got it</v-btn>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  methods: {
    ...mapMutations(["clearState"]),
    reset() {
      this.clearState();
      this.$router.push({ path: "/" });
    },
  },
};
</script>